import { createIcon } from '@chakra-ui/react';

export const Money = createIcon({
  displayName: 'Money',
  viewBox: '0 0 24 24',
  path: (
    <g id="Icon" transform="translate(-9 -709)">
      <rect
        id="Icon_Space"
        data-name="Icon Space"
        transform="translate(9 709)"
        fill="none"
      />
      <g id="SJ-Icon-B_Donate2_DkGray_RGB" transform="translate(9 709)">
        <path
          id="Path_2179"
          data-name="Path 2179"
          d="M22.947,7.294a11.98,11.98,0,1,0,.939,4.649A11.9,11.9,0,0,0,22.947,7.294ZM19.571,19.571A10.787,10.787,0,1,1,4.315,4.315,10.787,10.787,0,0,1,19.571,19.571Z"
          transform="translate(0)"
          fill="currentColor"
        />
        <path
          id="Path_2180"
          data-name="Path 2180"
          d="M268.99,163.366a5.807,5.807,0,0,0-2.512-.9v-3.826a5.064,5.064,0,0,1,2.417,1.046.578.578,0,1,0,.71-.912,6.176,6.176,0,0,0-3.127-1.3v-1.13a.578.578,0,1,0-1.156,0v1.1l-.19.013a3.117,3.117,0,0,0-3.124,2.986,2.629,2.629,0,0,0,.881,2.05,4.61,4.61,0,0,0,2.434.989v4.035a4.813,4.813,0,0,1-2.626-1.212.578.578,0,0,0-.812.823,5.521,5.521,0,0,0,2.153,1.267,6.866,6.866,0,0,0,1.285.289v1.162a.578.578,0,0,0,1.156,0v-1.114l.129-.007a4.723,4.723,0,0,0,2.367-.762,2.667,2.667,0,0,0,1.208-2.26A2.733,2.733,0,0,0,268.99,163.366Zm-5.827-2.92c0-.992.83-1.729,2.067-1.835l.092-.007v3.71C263.4,161.974,263.163,161.1,263.163,160.446Zm5.15,6.572a3.562,3.562,0,0,1-1.781.557l-.055,0V163.64c2.267.4,2.549,1.352,2.549,2.065A1.517,1.517,0,0,1,268.313,167.017Z"
          transform="translate(-253.957 -151.152)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
